import React, { Component } from "react";
import "./SMS.css";
import { Button,Jumbotron,Tabs,Tab,Table,FormGroup, Col,Form, FormControl,ControlLabel,Checkbox,Label,Well,ButtonToolbar,ToggleButton,ToggleButtonGroup} from "react-bootstrap";
import { API } from "aws-amplify";

import Moment from 'react-moment';
import moment from "moment"
import { CSVLink, CSVDownload } from "react-csv";
const log = (type) => console.log.bind(console, type);


var regnum=new RegExp(/^\+44\d{10,10}$/)


export default class SMSresp extends Component {
  constructor(props) {
  super(props);
  this.state = {
    data:[],
    numbers:[],
    summary:[],
    districts:[],
    distsum:[],
    new_number:"",
    new_name:"",
    date:new Date().getTime(),
    csvData:[],
    hightlight:"",
    messageInput:"",
    feedback:"",
    editIndex:-1,
    new_postcode:"",
    new_match:"",
    sortmode:"location",
    sortmodereverse:false
};
}

onTextChange=(event)=>{
      console.log(event.target.value)
      this.setState({messageInput:event.target.value})
}

async componentDidMount() {
  /* fetch('https://api.myjson.com/bins/'+this.props.match.params.id)
     .then(response => response.json())
     .then(data => this.setState({ form:data }));
     */
     console.log("Getting data")
     const responce=await this.getData("getAll");
     console.log(responce)
     this.setState({...responce})
     console.log(this.state)
     this.generateCSV()
 }





 handleChange = event => {
   let v=event.target.value
   if(event.target.id=="new_number"){
     v=v.replaceAll(" ","")
   }


   this.setState({
     [event.target.id]: v
   });
 }

generateCSV(){



  let tempCSV=[["Date Time","Number","Name","District","Area","Hours","RAW"]]

  for (var i=0;i<this.state.data.length;i++){
      tempCSV.push([moment(this.state.data[i].date.$date).format('YYYY-MM-DD HH:mm:ss'),"'"+this.state.data[i].number+"'",this.state.data[i].name,this.state.data[i].district,this.state.data[i].location,this.state.data[i].hours,this.state.data[i].raw])
  }
  console.log(tempCSV)
  this.setState({csvData:tempCSV})

}



 async sendData(parameters){
   let data = {
     'queryStringParameters': parameters
   }
   return API.get("AltiomData", "/forms/",data);
 }


 async getData(cmd){
   let data = {
     'queryStringParameters': {
         'cmd': cmd,
         'group':this.props.match.params.id
     }
   }
   return API.get("AltiomData", "/forms/",data);
 }


 updateMessage = async event=>{
   this.setState({feedback:"saving..."})
   let d={
     "cmd":"updateMessage",
     "message":this.state.messageInput,
     "group":this.props.match.params.id
   }
   let responce=await this.sendData(d)
//   this.setState({...responce})
    this.setState({feedback:"saved"})


 }


  checkNumber = async event => {

   console.log("Check number")

   if(this.state.new_number.match(regnum)!=null){
     console.log("Valid Number")

   }else{
     alert("Please Check mobile format, Should be +44xxxxxxxxxx")
     return
   }

   if(this.state.new_name.length==0){
     alert("Please provide a name!")
     return
   }

   let d={
     "cmd":"addNumber",
     "mobile":this.state.new_number,
     "name":this.state.new_name,
     "group":this.props.match.params.id
   }
   let responce=await this.sendData(d)
   this.setState({...responce})

 }

deleteNumbyId=async id=>{

  console.log("Delete "+id)
  let d={
    "cmd":"deleteNumbyId",
    "id":id,
    "group":this.props.match.params.id
  }
  let responce=await this.sendData(d)
  this.setState({...responce})

}

hightlight=(id)=>{
  console.log(id)
  this.setState({"hightlight":id})
}

changeState=async (index,value)=>{
  console.log("Button change")
  console.log(value)
  let temp=this.state.districts[index]
  temp.enabled=value
  //this.setState({districts:temp})
  let d={
    "cmd":"saveDistricts",
    "group":this.props.match.params.id,
    "data":JSON.stringify(temp)
  }
  let responce=await this.sendData(d)
  this.setState({...responce})

  }



  districtDelete=async (index)=>{
    let temp=this.state.districts[index]
    let d={
      "cmd":"deleteDistricts",
      "group":this.props.match.params.id,
      "data":JSON.stringify(temp)
    }
    let responce=await this.sendData(d)
    this.setState({...responce})

  }



districtEdit=(index)=>{
  if(this.state.editIndex!=-1){
    this.cancelEdit()
  }
  this.setState({"editIndex":index})
}

removeMatch=(index,m_index)=>{
  console.log("remove")
  console.log(index)
  console.log(m_index)
  let temp=this.state.districts
  console.log("remove:"+temp[index].match[m_index])
  temp[index].match.splice(m_index,1)
  console.log(temp)
  this.setState({districts:temp})
}

removePostcode=(index,p_index)=>{
  console.log("remove")
  console.log(index)
  console.log(p_index)
  let temp=this.state.districts
  console.log("remove:"+temp[index].postcodes[p_index])
  temp[index].postcodes.splice(p_index,1)
  console.log(temp)
  this.setState({districts:temp})
}

addPostcode=()=>{
  console.log("Add postcode")
  let temp=this.state.districts
  if(this.state.new_postcode.length>0){
    temp[this.state.editIndex].postcodes.push(this.state.new_postcode)
  }
  this.setState({new_postcode:""})
  this.setState({districts:temp})
}

addMatch=()=>{
  console.log("Add match")
  let temp=this.state.districts
  if(this.state.new_match.length>0){
    temp[this.state.editIndex].match.push(this.state.new_match.toLowerCase())
  }
  this.setState({new_match:""})
  this.setState({districts:temp})
}

nameChange=(event)=>{
  let temp=this.state.districts
  temp[this.state.editIndex].name=event.target.value
  this.setState({districts:temp})
}


saveDistrict=async ()=>{
  let temp=this.state.districts[this.state.editIndex]
  console.log(JSON.stringify(temp))
  let d={
    "cmd":"saveDistricts",
    "group":this.props.match.params.id,
    "data":JSON.stringify(temp)
  }
  let responce=await this.sendData(d)
  this.setState({...responce})
    this.setState({editIndex:-1})
}


hightlightON(d){
  if(d.location==this.state.hightlight)
      return "highligttext"

  if(d.district==this.state.hightlight)
    return "highligttext"


  return "nohighlight"


}

hightlightSort(d){

  if(d==this.state.sortmode){
    return "bolder"
  }
  return ""


}


hightlightONT(d){
  if(d.location==this.state.hightlight)
      return "*"

  if(d.district==this.state.hightlight)
    return "*"






  return ""


}


cancelEdit= async e=>{

  //request a copy of district data from the server
  this.setState({editIndex:-1})
  let d={
    "cmd":"getDistricts",
    "group":this.props.match.params.id
  }
  let responce=await this.sendData(d)
  this.setState({...responce})
}

newDistrict=()=>{
  let blank={
      "name":"new",
      "enabled":true,
      "group":this.props.match.params.id,
      "postcodes":[],
      "match":[]
  }
  let temp=this.state.districts
  temp.push(blank)
  this.setState({districts:temp})
  this.setState({editIndex:temp.length-1})



}

data_sort=(a,b)=>{

  let sA=a[this.state.sortmode]
  let sB=b[this.state.sortmode]
  if(this.state.sortmode=="date"){
    sA=a.date.$date
    sB=b.date.$date
  }


  if(sA<sB){
    if(this.state.sortmodereverse==true)
      return 1
    return -1
  }
  if(sA>sB){
    if(this.state.sortmodereverse==true)
      return -1
    return 1
  }
  return 0
}

changeSort=(key)=>{
  console.log(key)
  if(key==this.state.sortmode){
    console.log(this.state.sortmodereverse)
    this.setState({sortmodereverse:!this.state.sortmodereverse})
  }
  this.setState({sortmode:key})
}

  render() {
    return (
      <Jumbotron>


          <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="Response Data">
          <h3>Summary</h3>
          <Well>


          <h4>Districts</h4>
          <div className="flexHours">
            {this.state.distsum.map((d,index)=>
              <div onClick={()=>this.hightlight(d._id)}>
                <center><h2>{d._id}</h2></center>
                <center><span>{d.hours}h </span></center>
                 <center><span>{d.providors} provider{d.providors>1 ? ("s"):("")}</span></center>
              </div>
            )}
          </div>
          <h4>Locations</h4>
          <div className="flexHours">
            {this.state.summary.map((d,index)=>
              <div onClick={()=>this.hightlight(d._id)}>
                <center><h2>{d._id}</h2></center>
                <center><span>{d.hours}h </span></center>
                 <center><span>{d.providors} provider{d.providors>1 ? ("s"):("")}</span></center>
              </div>
            )}
            </div>
            </Well>
          <h3>Full Data</h3>
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th className={this.hightlightSort("name")}>Name <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('name')}></i></th>
                <th className={this.hightlightSort("district")}>District <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('district')}></i></th>
                <th className={this.hightlightSort("location")}>Location <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('location')}></i></th>
                <th className={this.hightlightSort("hours")}>Hours <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('hours')}></i></th>
                <th className={this.hightlightSort("date")}>Time <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('date')}></i></th>
              </tr>
            </thead>

          <tbody>
            {this.state.data.sort((a,b)=>this.data_sort(a,b,this.state.sortmode)).map((d,index)=>


              <tr key={d._id.$oid} className={this.hightlightON(d)} title={d.raw}>
                <td>{this.hightlightONT(d)}{d.name} ({d.number})</td>
                <td>{d.district} </td>
                <td>{d.location} </td>
                <td>{d.hours} </td>
                <td>{moment(d.date.$date).format('HH:mm ')} </td>
              </tr>

        )}
        </tbody>
        </Table>
        <CSVLink   filename={"export_"+moment(this.state.date).format('YYYY-MM-DD hh:mm')+".csv"} data={this.state.csvData} target="_blank" >Export as CSV</CSVLink >
          </Tab>
          <Tab eventKey={2} title="Numbers">
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>Number</th>
                <th>Name</th>
              </tr>
            </thead>

          <tbody>
            {this.state.numbers.map((d,index)=>

              <tr key={d._id.$oid} >
                <td>{d.number} <a onClick={()=>this.deleteNumbyId(d._id.$oid)}>(delete number)</a></td>
                <td>{d.name} </td>

              </tr>

        )}
        </tbody>
        </Table>
        <hr/>




        <div>
      <FormGroup controlId="new_number">
        <Col componentClass={ControlLabel} sm={2}>
          Mobile Number
        </Col>
        <Col sm={10}>
          <FormControl type="tel" placeholder="Mobile number +44XXXXXXXXXX" value={this.state.new_number}        onChange={this.handleChange}/>
        </Col>
      </FormGroup>
      <FormGroup controlId="new_name">
        <Col componentClass={ControlLabel} sm={2}>
          Name
        </Col>
        <Col sm={10}>
          <FormControl type="text" placeholder="Name of provider"     value={this.state.new_name}       onChange={this.handleChange}/>
        </Col>
      </FormGroup>
      </div>

      <hr/>

        <Button onClick={this.checkNumber}>Add Number</Button>
        <hr/>
              <Well>
        <h2>Configure the message</h2>
        <textarea rows="4" cols="40" value={this.state.messageInput} onChange={this.onTextChange}></textarea><b>{this.state.messageInput.length}/160</b><br/>
        <Button onClick={this.updateMessage}>Update message</Button>
        <span>&nbsp;{this.state.feedback}</span>
        </Well>
        <hr/>
        <Well>
        <h3>SMS Number: 07860098848</h3>
        <span>Text:<b>REG</b> Company Name --- <i>To register a name against the number</i></span>
        <br/>
        <Well>REG My comapany name</Well>

        <span>Text:<b>Hours Location, Hours Location</b> <i>Add data to the system</i></span>
        <br/>
        <Well>10 WR1, 22 WR2, 40 WR</Well>
        <ul>
        <li>10 hours for WR1</li>
        <li>22 hours for WR2</li>
        <li>40 hours for WR</li>
        </ul>
        </Well>

        </Tab>



        <Tab eventKey={3} title="Districts">


        <h3>Districts</h3>
          <span>Certain keywords can be expanded out to a group of postcodes. These can be modified here</span>
          <br/>
          <br/>
    {this.state.districts.map((d,index)=>

<Well>
    {this.state.editIndex!=index ?(
      <div>
    <h2>{d.name}&nbsp;
      <ToggleButtonGroup type="radio" name="options" value={d.enabled} onChange={(evt)=>this.changeState(index,evt)}>
        <ToggleButton value={true}>Enable</ToggleButton>
        <ToggleButton value={false}>Disable</ToggleButton>
      </ToggleButtonGroup>
      </h2>
      <span>
      <h4>Match against:</h4>
      {d.match.map((m,mindex)=>
        <Label className="padlab">{m}</Label>
      )}
      <h4>Postcodes:</h4>
      {d.postcodes.map((p,pindex)=>
        <Label className="padlab" bsStyle="primary">{p}</Label>
      )}
      </span>
      <br/>
      <br/>
      <Button onClick={()=>this.districtEdit(index)}>Edit</Button>&nbsp;
      <Button bsStyle="danger" onClick={()=>this.districtDelete(index)}>Delete</Button>

      </div>
    ):(<div>
        <h3>Name</h3>
          <input value={d.name} onChange={this.nameChange}></input>
        <h4>Keywords <span><small>words to match against in lowercase</small></span></h4>
        {d.match.map((m,mindex)=>
          <Button key={index+"M"+mindex} className="padlab"  onClick={()=>this.removeMatch(index,mindex)}>{m} (remove)</Button>
        )}
        <br/>
        <br/>
        <br/>
        <Form inline>
        <FormGroup controlId="new_match">
            <FormControl type="text" placeholder="word to match" value={this.state.new_match} onChange={this.handleChange}/>
        </FormGroup>
        <br/>
        <Button bsStyle="warning" onClick={()=>this.addMatch()}>Add Word</Button>
        </Form>
        <h4>Postcodes <span><small>postodes to be inserted</small></span></h4>
        {d.postcodes.map((p,pindex)=>
          <Button key={index+"P"+pindex} className="padlab" onClick={()=>this.removePostcode(index,pindex)}>{p} (remove)</Button>
        )}
        <br/>
        <br/>
        <br/>
        <Form inline>
        <FormGroup controlId="new_postcode">
            <FormControl type="text" placeholder="postcode to add" value={this.state.new_postcode} onChange={this.handleChange}/>
        </FormGroup>
        <br/>
        <Button bsStyle="warning" onClick={()=>this.addPostcode()}>Add Postcode</Button>
        </Form>
        <hr/>
        <Button bsStyle="primary" onClick={()=>this.saveDistrict()}>Save Changes</Button>
        <Button onClick={()=>this.cancelEdit()}>Cancel</Button>

      </div>)}

</Well>)
    }
    {this.state.editIndex==-1 ? <Button bsStyle="primary" onClick={()=>this.newDistrict()}>Add New</Button>:""}

        </Tab>




        </Tabs>




        </Jumbotron>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SMSresp.js